import React from "react";
import ReactDOM from 'react-dom/client';
import avtlogo from './img/logo-blue.png'; 
import Apprt from './App';
import Modal from './components/LoginModal';
import './assets/css/Login.css'
import axios from 'axios';
import { removeUserSession, setUserSession,auTHURL } from './utils/common.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ForgetPassword from './components/ForgetPassword.js';
//import AdmMaster from  './components/AdminMaster';
//import CDashboard from './components/ClientApplication/CDashboard';


class Login extends React.Component 
{
  
   
  constructor(props) 
  {
    super(props);
    this.state = {
     showLogin: false, 
     showForgetPassword:false,  
     showSendOtpBtn:false,
     showResendOtpBtn:true, 
     showResetPassword:false,
     fpOtp:"",
     pVisible: false,
      message:'',
      logInfo:{
                UserName: "",
                Password: ""
             },
           forgetPasswordInfo:{
                fMobile: "",
                fOtp: "",
                fnewPassword: "",
                fconfirmPassword: ""              
          }
    };
     
  }
  
  onClickForgetPassword=()=>{     
     
     this.setState({ showLogin: false });
     this.setState({ showForgetPassword: true });
     this.setState({ showSendOtpBtn: false });  
     this.setState({ showResendOtpBtn: true });
    
  }
  closeForgetPassword=()=>{

     this.setState({ showLogin: false });
     this.setState({ showForgetPassword: false });
  }
  changeFPHandler=e=>{
  const name=e.target.name;
  const value= e.target.value;
  this.setState({
            forgetPasswordInfo:{
                ...this.state.forgetPasswordInfo,
                [name]:value
           }}
  );
}
  onClickLogin=()=>{

      if(!this.state.logInfo.UserName)
      {
          toast.error("User name is required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
          
          return;
      }
      else  if(!this.state.logInfo.Password)
      {
          toast.error("Password is required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
          return;
      }
      else
      {
      const params = JSON.stringify({

        "Username": this.state.logInfo.UserName,
        "Password": this.state.logInfo.Password,
        "Role": "Customer"//,
        //"UserType": "Admin",
            
      });
        let AUTH_URL=auTHURL();       
        // alert(process.env.NODE_ENV);
         //alert(AUTH_URL);
         axios.post(AUTH_URL+'login', params,{        
              "headers": {          
              "content-type": "application/json",          
          },          
          })
          .then(function(response) 
          {
                 
                  console.log("--------------start-------------------");                           
                  if(JSON.parse(JSON.stringify(response.data.message))==='Logged in')
                  {
                          setUserSession(response.data.token, response.data.userName,response.data.userRole,response.data.actorID,response.data.name,response.data.customerTypeId);
                          const root = ReactDOM.createRoot(document.getElementById('root'));                          
                          root.render(<Apprt/>);
                                                   
                  }   
                  else
                  {       
                          removeUserSession();
                          console.log("---------Error----------");
                          toast.error(response.data.message,{ position: "bottom-right", autoClose: 4000, theme: "light"});                         
                  }           
           })
          
          .catch(function(error) 
          {
                  removeUserSession();                 
                  toast.error(error,{ position: "bottom-right", autoClose: 4000, theme: "light"});                    
                  console.log(error);
          
          });
                      
        }
     /* 
    const AuthURL=auTHURL();     
      if(!this.state.logInfo.UserName)
      {
          toast.error("User Name is Required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
          
          return;
      }
      else  if(!this.state.logInfo.Password)
      {
          toast.error("Password is Required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
          return;
      }
      else
      {
      const params = JSON.stringify({

        "Username": this.state.logInfo.UserName,
        "Password": this.state.logInfo.Password,
        "Role": "Admin",
        "UserType": "Admin",
            
      });
      
      axios.post(AuthURL+'login', params,{
       
          "headers": {          
          "content-type": "application/json",          
          },          
          })
          .then(function(response) 
          {
                 
                  console.log("--------------start-------------------");  
                  console.log(response.data);            
                  if(JSON.parse(JSON.stringify(response.data.message))==='Logged in')
                  {
                          setUserSession(response.data.token, response.data.userName,response.data.userRole,response.data.actorID,response.data.name);
                          const root = ReactDOM.createRoot(document.getElementById('root'));
                          root.render(<Apprt/>);
                                           
                  }   
                  else
                  {       
                          removeUserSession();
                          console.log("---------Error----------");
                          console.log(response.data.message);
                          toast.error(response.data.message,{ position: "bottom-right", autoClose: 4000, theme: "light"});                         
                  }           
           })
          
          .catch(function(error) 
          {
                  removeUserSession();
                  alert(error);
                  alert(JSON.stringify(error.data));
                  console.log(error);
          
          });
                        console.log(this.state.logInfo)
        }*/
  }
handleUsernameKeyDown(event) 
{
    if (event.keyCode === 13) {
        document.getElementById('Password').focus();
      }
    }
handlePasswordKeyDown(event) 
{
    if (event.keyCode === 13) {
          document.getElementById('signin').focus();
          //this.onClickLogin();
      }
    }
setVisible=()=>
     {
            if(this.state.pVisible)
            {
                    this.setState({ pVisible: false });
            }
            else
             {
                    this.setState({ pVisible: true });
            }
     }
changeHandler=e=>{
      
     const name=e.target.name;
     const value= e.target.value;

     this.setState({
              logInfo:{
                   ...this.state.logInfo,
                   [name]:value
              }}
     );
     
}
  render() 
  {
     return (
      <>

      <div>
      <div className="content-bg-wrap"></div>
      <div className="login-container display-flex">
      <div className="avt-login">
         <div className="login-top text-center" > <img src= {avtlogo} alt="AVT LOGO" /> </div>
           <div className="login-body">
           <h4 className="text-center">Login</h4>
             <div className="form-group"> User Name
                    <input id="UserName" autofocus="autofocus"   name="UserName" type="text" required="required" className="form-control" onChange={this.changeHandler} onKeyDown={this.handleUsernameKeyDown}></input>
              </div>
              <div className="form-group"> Password
                   <input id="Password" name="Password" type={this.state.pVisible ? "text" : "password"} required="required" autoComplete="new-password"  className="form-control"
                onChange={this.changeHandler} onKeyDown={this.handlePasswordKeyDown}></input>
                 <span onClick={() => this.setVisible()} style={{ position: "absolute", right: "20px",top: "65%",transform: "translateY(-50%)",cursor: "pointer",}}>
                {this.state.pVisible ? <i class="fas fa-eye-slash"></i> : <i class="fas fa-eye"></i>} </span>
              </div>
              <div className="form-group text-right forgotLink"><button id='ForgetPasswordButton' onClick={this.onClickForgetPassword}  style={{ background:"none", border:"none", color:'blue', cursor:"pointer", float:'right' }} title="Forget Password"> Forget Password?</button> </div>
              <div className="text-center">
                <button type="submit" id="signin" onClick={this.onClickLogin} className="btn login-btn">Login</button>
                <p>{this.state.message}</p>
              </div>
          </div></div>
        </div> 
        </div>  
        <Modal isOpen={this.state.showForgetPassword} >
  
           <div class="modal-header justify-content-center bg-white border-0">
                <h5 className='modal-title'>Forget Password</h5>
                <button type="button" class="btn-close" onClick={this.closeForgetPassword}></button>
                </div>
                <div class="modal-body">    
                  <ForgetPassword/>        
                 </div>
        </Modal>  
        <ToastContainer />   
        </>    
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Login/>);
export default Login;
